<form #formEndereco="ngForm">
    <div class="row">
        <h2>Endereço Residencial - Avalista
            <span *ngIf="fichaCadastro.avalistas.length > 1">{{ numeroAvalista }}</span>
        </h2>
        <app-endereco icon="residencial" label="CEP" name="enderecoResidencial" [(ngModel)]="fichaCadastro?.avalistas[index].enderecos" [cep]="getCep()" ngDefaultControl>
        </app-endereco>
    </div>
    <!-- COMERCIAL -->
    <div *ngIf="fichaCadastro?.avalistas[index]?.dadoProfissional?.classeProfissional?.empresa" class="row">
        <h2>Endereço Comercial - Avalista
            <span *ngIf="fichaCadastro.avalistas.length > 1">{{ numeroAvalista }}</span>
        </h2>
        <app-endereco icon="icon zip-code" label="CEP" name="enderecoComercial" [(ngModel)]="fichaCadastro?.avalistas[index].dadoProfissional.empresa.endereco"  [cep]="getCepComercial()" ngDefaultControl>
        </app-endereco>
    </div>
    <!-- SELECIONAR ENDEREÇO PARA CORRESPONDÊNCIA -->
    <div class="row">
        <div class="form-group">
            <span class="icon email"></span>
            <div class="inputs">
                <label for="user-mail-address">Endereço para correspondência</label>
                <select name="user-mail-address" id="user-mail-address" class="form-control" required [(ngModel)]="fichaCadastro?.avalistas[index].tipoEnderecoCorrespondencia">
                  <option value="undefined" hidden selected>Selecione</option>
                  <option value="1">Residencial</option>
                  <option *ngIf="fichaCadastro?.avalistas[index]?.dadoProfissional?.classeProfissional?.empresa" value="2">Comercial</option>
                  <option value="7">Outro</option>
              </select>
            </div>
        </div>
    </div>
</form>
<form #formEnderecoOutro="ngForm">
    <!-- OUTRO -->
    <div class="row mail-address" [ngClass]="{'dn': fichaCadastro?.avalistas[index].tipoEnderecoCorrespondencia !== '7'}">
        <h2>Endereço Correspondência - Avalista
            <span *ngIf="fichaCadastro.avalistas.length > 1">{{ numeroAvalista }}</span>
        </h2>
        <app-endereco icon="icon zip-code" label="CEP" name="enderecoComercial" [(ngModel)]="fichaCadastro?.avalistas[index].enderecoCorrespondencia" [cep]="getCep(true)" ngDefaultControl>
        </app-endereco>
    </div>
</form>

<!-- BOTÕES -->
<div class="row">
    <div class="marginT30 form-group tab-buttons">
        <a (click)="onClickPrevious()" class="bt-back btn btn-border-orange pull-left"><em class="fa fa-arrow-left mrBt"></em> Voltar</a>
        <a class="bt-go btn btn-full-orange pull-right" [ngClass]="{'disabled': !nextAvaliable(formEndereco.valid, formEnderecoOutro.valid)}" (click)="onClickNext()">Continuar <em class="fa fa-arrow-right mlBt"></em></a>
    </div>
</div>
